/* CLTR extras: review stars on product cards (data from snippets/cltr-ratings.liquid) */
(function () {
  'use strict';
  var data = window.cltrRatings || {};
  if (!Object.keys(data).length) return;

  function handleOf(card) {
    var a = card.querySelector('a.product-card__link, a.cltr2-card__link');
    if (!a || !a.pathname || a.pathname.indexOf('/products/') === -1) return null;
    try { return decodeURIComponent(a.pathname.split('/products/')[1].split('/')[0]); } catch (e) { return null; }
  }
  function titleEl(card) {
    var n = card.querySelector('.cltr2-card__name');
    if (n) return n;
    var a = card.querySelector('a.product-card__link');
    var t = a && (a.getAttribute('aria-label') || '').trim();
    if (!t) return null;
    var els = card.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,div');
    var best = null;
    for (var i = 0; i < els.length; i++) {
      if (els[i].children.length < 2 && (els[i].textContent || '').trim() === t) best = els[i];
    }
    return best;
  }
  function run() {
    var cards = document.querySelectorAll('product-card:not([data-cs]), .cltr2-card:not([data-cs])');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      c.setAttribute('data-cs', '');
      var h = handleOf(c);
      var r = h && data[h];
      if (!r || c.querySelector('.cltr-card-stars')) continue;
      var s = document.createElement('span');
      s.className = 'cltr-card-stars';
      s.setAttribute('aria-label', 'Rated ' + r[0] + ' out of 5 from ' + r[1] + (r[1] === 1 ? ' review' : ' reviews'));
      s.innerHTML = '<span aria-hidden="true">★</span> ' + Number(r[0]).toFixed(1) + ' <em aria-hidden="true">(' + r[1] + ')</em>';
      var t = titleEl(c);
      if (t && t.parentNode) t.parentNode.insertBefore(s, t.nextSibling);
    }
  }
  var q = false;
  new MutationObserver(function () {
    if (q) return;
    q = true;
    requestAnimationFrame(function () { q = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
